export const PICKUP_CONTACT = 'shipFromContactId';
export const AVAILABLE_START_TIME = 'startTime';
export const AVAILABLE_END_TIME = 'endTime';
export const PREFERRED_TIME = 'preferredTime';
export const INSTRUCTIONS = 'instructions';
